export function toSafeErrorLog(err) {
  return {
    name: err?.name,
    message: err?.message,
    code: err?.code,
    status: err?.response?.status,
    method: err?.config?.method,
    path: err?.config?.url,
    requestId: err?.response?.headers?.['x-request-id'],
    // optional in dev only:
    stack: process.env.NODE_ENV === 'development' ? err?.stack : undefined,
  }
}
